import * as types from "../constants/home";
import images from "../../Constant/images";

const INITIAL_STATE = {
  isLoading: false,
  userLoading: false,
  courseLoading: false,
  waitingCourseLoading: false,
  newCourseLoading: false,
  stripeLoading: false,
  success: false,
  error: null,
  selectedChat: null,
  total_courses: 0,
  total_students: 0,
  credit_hours: 0,
  isCourseCreated: false,
  courseContent: {},
  contentLoading: false,
  courseChatLoading:false,
  courses: [],
  news: [],
  downloadedNews: [],
  newsLoading: false,
  enrollReqList: [],
  new_courses: [],
  awaiting_courses: [],
  chatList: [],
  chat: [],
  folders: [],
  mailList: [],
  req_count: 0,
  isContentUpload: false,
  courseDetails: {},
  quizDetails: [],
  allCourses: [],
  userList: [],
  adminList: [],
  courseUsers: {},
  coursesErrors: null,
  quizLoading: false,
  profile: {},
  slugList: [],
  materialList: [],
  oldMessages: [],
};

export default function homeReducer(state = INITIAL_STATE, action) {
  const newState = JSON.parse(JSON.stringify(state));
  const { chatList, courses, allCourses, folders, mailList } = newState;
  let fold = JSON.parse(JSON.stringify(folders));

  switch (action.type) {
    // GET_DASHBOARD
    case types.GET_DASHBOARD_REQUEST:
      return {
        ...newState,
        isLoading: true,
      };
    case types.GET_DASHBOARD_SUCCESS:
      // console.log("GET_DASHBOARD_SUCCESS", action?.response?.data);
      return {
        ...newState,
        isLoading: false,
        chatList: action?.response?.data?.chats,
        folders: action?.response?.data?.folders,
        total_courses: action?.response?.data?.total_courses ?? 0,
        total_students: action?.response?.data?.total_students ?? 0,
        credit_hours: action?.response?.data?.credit_hours ?? 0,
        grades: action?.response?.data?.grades ?? 0,
      };
    case types.GET_DASHBOARD_FAILED:
      return {
        ...newState,
        isLoading: false,
      };

    // GET_USERS
    case types.GET_USERS_REQUEST:
      return {
        ...newState,
        userLoading: true,
      };
    case types.GET_USERS_SUCCESS:
      // console.log("GET_USERS_SUCCESS", action);
      return {
        ...newState,
        userLoading: false,
        userList: action?.response?.results ?? [],
        user_count: action?.response?.count ?? 0,
      };
    case types.GET_USERS_FAILED:
      return {
        ...newState,
        userLoading: false,
      };

    // GET_ADMINS
    case types.GET_ADMINS_REQUEST:
      // console.log("GET_ADMINS_REQUEST", action);

      return {
        ...newState,
        userLoading: true,
      };
    case types.GET_ADMINS_SUCCESS:
      // console.log("GET_ADMINS_SUCCESS", action);
      return {
        ...newState,
        userLoading: false,
        adminList: action?.response ?? [],
      };
    case types.GET_ADMINS_FAILED:
      return {
        ...newState,
        userLoading: false,
      };

    // GET_COURSES
    case types.GET_COURSES_REQUEST:
      return {
        ...newState,
        myCourseLoading: true,
      };
    case types.GET_COURSES_SUCCESS:
      let isChat = action.action.limit === 100;
      // console.log("GET_COURSES_SUCCESS", action, isChat);

      return {
        ...newState,
        myCourseLoading: false,
        courses: isChat ? courses : action?.response?.results,
        my_courses_count: action?.response?.count ?? 0,
        allCourses: isChat ? action?.response?.results : allCourses,
      };
    case types.GET_COURSES_FAILED:
      return {
        ...newState,
        myCourseLoading: false,
      };

    // GET_NEW_COURSES
    case types.GET_NEW_COURSES_REQUEST:
      return {
        ...newState,
        newCourseLoading: true,
      };
    case types.GET_NEW_COURSES_SUCCESS:
      // console.log("GET_NEW_COURSES_SUCCESS", action);
      return {
        ...newState,
        newCourseLoading: false,
        new_courses: action?.response?.results ?? [],
        new_courses_count: action?.response?.count ?? 0,
      };
    case types.GET_NEW_COURSES_FAILED:
      return {
        ...newState,
        newCourseLoading: false,
      };

    // GET_WAITING_COURSES
    case types.GET_WAITING_COURSES_REQUEST:
      return {
        ...newState,
        waitingCourseLoading: true,
        isCourseCreated: false,
      };
    case types.GET_WAITING_COURSES_SUCCESS:
      return {
        ...newState,
        waitingCourseLoading: false,
        awaiting_courses: action?.response?.results ?? [],
        awaiting_courses_count: action?.response?.count ?? 0,
      };
    case types.GET_WAITING_COURSES_FAILED:
      return {
        ...newState,
        waitingCourseLoading: false,
      };

    // POST_COURSE
    case types.POST_COURSE_REQUEST:
      return {
        ...newState,
        courseLoading: true,
        isCourseCreated: false,
        coursesErrors: null,
      };
    case types.POST_COURSE_SUCCESS:
      // console.log("POST_COURSE_SUCCESS", action);
      return {
        ...newState,
        courseLoading: false,
        isCourseCreated: true,
        coursesErrors: null,
      };
    case types.POST_COURSE_FAILED:
      // console.log("POST_COURSE_FAILED", action);
      return {
        ...newState,
        courseLoading: false,
        isCourseCreated: false,
      };

    // PATCH_COURSE
    case types.PATCH_COURSE_REQUEST:
      return {
        ...newState,
        courseLoading: true,
        isCourseCreated: false,
        coursesErrors: null,
      };
    case types.PATCH_COURSE_SUCCESS:
      // console.log("PATCH_COURSE_SUCCESS", action);
      return {
        ...newState,
        courseLoading: false,
        isCourseCreated: true,
        coursesErrors: null,
      };
    case types.PATCH_COURSE_FAILED:
      // console.log("PATCH_COURSE_FAILED", action?.response?.response?.data);
      return {
        ...newState,
        courseLoading: false,
        isCourseCreated: false,
        coursesErrors: action?.response?.response?.data,
      };

    // GET_COURSE_ENROLL_REQ
    case types.GET_COURSE_ENROLL_REQ_REQUEST:
      return {
        ...newState,
        userLoading: true,
      };
    case types.GET_COURSE_ENROLL_REQ_SUCCESS:
      return {
        ...newState,
        userLoading: false,
        enrollReqList: action?.response.results ?? [],
        req_count: action?.response.count ?? 0,
      };
    case types.GET_COURSE_ENROLL_REQ_FAILED:
      return {
        ...newState,
      };

    // GET_CONTENT
    case types.GET_CONTENT_REQUEST:
      // console.log("GET_CONTENT_REQUEST", action);
      return {
        ...newState,
        contentLoading: true,
        courseContent: [],
      };
    case types.GET_CONTENT_SUCCESS:
      // console.log("GET_CONTENT_SUCCESS", action);
      return {
        ...newState,
        contentLoading: false,
        courseContent: action?.response?.material ?? [],
        contentCount: action?.response?.count ?? 0,
      };
    case types.GET_CONTENT_FAILED:
      return {
        ...newState,
        contentLoading: false,
      };

    // POST_CONTENT
    case types.POST_CONTENT_REQUEST:
      return {
        ...newState,
        contentLoading: true,
        isContentUpload: false,
      };
    case types.POST_CONTENT_SUCCESS:
      return {
        ...newState,
        contentLoading: false,
        isContentUpload: true,
      };
    case types.POST_CONTENT_FAILED:
      return {
        ...newState,
        contentLoading: false,
        isContentUpload: false,
      };

    // GET_NEWS
    case types.GET_NEWS_REQUEST:
      return {
        ...newState,
        newsLoading: true,
      };
    case types.GET_NEWS_SUCCESS:
      // console.log("GET_NEWS_SUCCESS", action);
      return {
        ...newState,
        newsLoading: false,
        news: action?.response?.results ?? [],
      };
    case types.GET_NEWS_FAILED:
      return {
        ...newState,
        newsLoading: false,
      };


    // STRIPE_ONBOARD_REQUEST
    case types.STRIPE_ONBOARD_REQUEST:
      return {
        ...newState,
        stripeLoading: true,
      };
    case types.STRIPE_ONBOARD_SUCCESS:
      // console.log("STRIPE_ONBOARD_SUCCESS", action);
      return {
        ...newState,
        stripeLoading: false,
      };
    case types.STRIPE_ONBOARD_FAILED:
      return {
        ...newState,
        stripeLoading: false,
      };


    // GET_DOWNLOADED_NEWS
    case types.GET_DOWNLOADED_NEWS_REQUEST:
      return {
        ...newState,
        newsLoading: true,
      };
    case types.GET_DOWNLOADED_NEWS_SUCCESS:
      // console.log("GET_DOWNLOADED_NEWS_SUCCESS", action);
      return {
        ...newState,
        newsLoading: false,
        downloadedNews: action?.response?.results ?? [],
      };
    case types.GET_DOWNLOADED_NEWS_FAILED:
      return {
        ...newState,
        newsLoading: false,
      };

    // POST_NEWS
    case types.POST_NEWS_REQUEST:
      return {
        ...newState,
      };
    case types.POST_NEWS_SUCCESS:
      return {
        ...newState,
      };
    case types.POST_NEWS_FAILED:
      return {
        ...newState,
      };

    // POST_QUIZ
    case types.POST_QUIZ_REQUEST:
      return {
        ...newState,
        quizLoading: true,
      };
    case types.POST_QUIZ_SUCCESS:
      return {
        ...newState,
        quizLoading: false,
      };
    case types.POST_QUIZ_FAILED:
      return {
        ...newState,
        quizLoading: false,
      };

    // GET_QUIZ_DETAILS
    case types.GET_QUIZ_DETAILS_REQUEST:
      return {
        ...newState,
        quizLoading: true,
      };
    case types.GET_QUIZ_DETAILS_SUCCESS:
      return {
        ...newState,
        quizLoading: false,
        quizDetails: action?.response,
      };
    case types.GET_QUIZ_DETAILS_FAILED:
      return {
        ...newState,
        quizLoading: false,
      };

    // POST_SUBMIT_QUIZ
    case types.POST_SUBMIT_QUIZ_REQUEST:
      return {
        ...newState,
        quizLoading: true,
      };
    case types.POST_SUBMIT_QUIZ_SUCCESS:
      return {
        ...newState,
        quizLoading: false,
      };
    case types.POST_SUBMIT_QUIZ_FAILED:
      return {
        ...newState,
        quizLoading: false,
      };

    // GET_COURSE_USERS
    case types.GET_COURSE_USERS_REQUEST:
      return {
        ...newState,
        courseChatLoading: true,
      };
    case types.GET_COURSE_USERS_SUCCESS:
      return {
        ...newState,
        courseChatLoading: false,
        courseUsers: {
          instructor: action?.response?.instructor,
          students: action?.response?.students,
        },
      };
    case types.GET_COURSE_USERS_FAILED:
      return {
        ...newState,
        courseChatLoading: false,
      };
    // GET_COURSE_MESSAGES
    case types.GET_COURSE_MESSAGES_REQUEST:
      return {
        ...newState,
        courseChatLoading: true,
        oldMessages:[]
      };
    case types.GET_COURSE_MESSAGES_SUCCESS:
      // console.log("GET_COURSE_MESSAGES_SUCCESS", action);
      return {
        ...newState,
        courseChatLoading: false,
        oldMessages: action?.response?.results.length
          ? action?.response?.results[0]?.messages
          : [],
      };
    case types.GET_COURSE_MESSAGES_FAILED:
      return {
        ...newState,
        courseChatLoading: false,
      };

    // TOGGLE_FOLDERS
    case types.TOGGLE_FOLDERS:
      folders.filter((f) => {
        if (f.folder_name === action?.payload) {
          f.toggle = !f.toggle;
        }
      });
      // console.log("TOGGLE_FOLDERS", action, folders);
      return { ...newState };

    case types.TOGGLE_FOLDERS_COURSES:
      fold.filter((f) => {
        if (f.id === action?.payload?.folderId) {
          let arr = f.courses;
          arr.filter((c) => {
            if (c.name === action?.payload?.courseId) {
              c.toggleCourse = !c.toggleCourse;
            }
          });
          f.courses = arr;
        }
      });
      return {
        ...newState,
        folders: fold,
      };

    case types.OPEN_MAIL:
      mailList.filter((f) => {
        if (f.id === action?.payload?.id) {
          f.isRead = true;
        }
        mailList.forEach((fe) => {
          if (fe.id === action?.payload?.id) {
            fe.isSelected = true;
            fe.unread = false;
          } else {
            fe.isSelected = false;
          }
        });
      });
      return { ...newState };

    case types.TOGGLE_USER_CHAT:
      // console.log("TOGGLE_USER_CHAT", action.payload);
      let chat = {};
      let list = [...chatList];
      chatList.filter((f) => {
        if (f.id === action?.payload?.id) {
          f.toggle = !f.toggle;
          chat = f;
        }
      });
      return {
        ...newState,
        selectedChat: chat,
        chatList: list,
      };

    // GET_ALL_CONTENTS
    case types.GET_ALL_CONTENTS_REQUEST:
      return {
        ...newState,
        contentLoading: true,
      };
    case types.GET_ALL_CONTENTS_SUCCESS:
      // console.log("GET_ALL_CONTENTS_SUCCESS", action);
      return {
        ...newState,
        contentLoading: false,
        courseContent: action?.response?.material ?? [],
      };
    case types.GET_ALL_CONTENTS_FAILED:
      return {
        ...newState,
        contentLoading: false,
      };

    // GET_SLUG
    case types.GET_SLUG_REQUEST:
      return {
        ...newState,
        isLoading: true,
      };
    case types.GET_SLUG_SUCCESS:
      // console.log("GET_SLUG_SUCCESS", action);
      return {
        ...newState,
        isLoading: false,
        slugList: action?.response?.results ?? [],
      };
    case types.GET_SLUG_FAILED:
      return {
        ...newState,
        isLoading: false,
      };

    // GET_MAIL
    case types.GET_MAIL_REQUEST:
      return {
        ...newState,
        isLoading: true,
      };
    case types.GET_MAIL_SUCCESS:
      // console.log("GET_MAIL_SUCCESS", action);
      return {
        ...newState,
        isLoading: false,
        mailList: action?.response?.results ?? [],
      };
    case types.GET_MAIL_FAILED:
      return {
        ...newState,
        isLoading: false,
      };

    // READ_MAIL
    case types.READ_MAIL_REQUEST:
      return {
        ...newState,
        isLoading: false,
      };
    case types.READ_MAIL_SUCCESS:
      // console.log("READ_MAIL_SUCCESS", action);
      return {
        ...newState,
        isLoading: false,
      };
    case types.READ_MAIL_FAILED:
      return {
        ...newState,
        isLoading: false,
      };

    // GET_S3_URL
    case types.GET_S3_URL_REQUEST:
      return {
        ...newState,
        isLoading: false,
      };
    case types.GET_S3_URL_SUCCESS:
      // console.log("GET_S3_URL_SUCCESS", action);
      return {
        ...newState,
        isLoading: false,
      };
    case types.GET_S3_URL_FAILED:
      return {
        ...newState,
        isLoading: false,
      };

    case types.CLEAR_HOME:
      return {
        ...newState,
        selectedChat: null,
        total_courses: 0,
        total_students: 0,
        credit_hours: 0,
        isCourseCreated: false,
        courseContent: {},
        contentLoading: false,
        courses: [],
        news: [],
        downloadedNews: [],
        newsLoading: false,
        enrollReqList: [],
        new_courses: [],
        awaiting_courses: [],
        chatList: [],
        chat: [],
        folders: [],
        mailList: [],
        req_count: 0,
        isContentUpload: false,
        courseDetails: {},
        quizDetails: [],
        allCourses: [],
        userList: [],
        adminList: [],
        courseUsers: {},
        coursesErrors: null,
        quizLoading: false,
        profile: {},
        slugList: [],
        materialList: [],
        oldMessages: [],
      };

    default:
      return state;
  }
}
